// @ts-nocheck
interface StatCardProps {
  label: string;
  value: string | number;
  iconClass: string;
  gradient?: "primary" | "success" | "info" | "warning" | "danger" | "default";
}

const gradientMap = {
  primary: "gradient-primary",
  success: "gradient-success",
  info: "gradient-info",
  warning: "gradient-warning",
  danger: "gradient-danger",
  default: "gradient-default",
};

export function StatCard({ label, value, iconClass, gradient = "primary" }: StatCardProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-[#e9ecef] p-5">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wider text-[#8898aa] mb-1">{label}</p>
          <p className="text-2xl font-bold text-[#32325d]">{value}</p>
        </div>
        <div className={`icon-shape ${gradientMap[gradient]} shrink-0 ml-3`}>
          <i className={iconClass} />
        </div>
      </div>
    </div>
  );
}
